import React from 'react';
import "../css/footer.css";

const Footer = () => {
   return (
      <footer>
         This site was built with React. 😎<br></br>2022 | Max Morse
      </footer>
   );
}

export default Footer;